<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('producttypefiletype_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-producttypefiletype-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                                    {{ item['namefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.notice') }}</strong></td>
              <td>
                <span v-if="item.notice" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
              <td><strong>{{ $t('qualitycheck.product.updatesoft') }}</strong></td>
              <td>
                <span v-if="item.updateSoft" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.factoryreset') }}</strong></td>
              <td>
                <span v-if="item.factoryReset" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
              <td><strong>{{ $t('qualitycheck.product.material') }}</strong></td>
              <td>
                <span v-if="item.material" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';


const servicePrefix = 'Producttypefiletype';

export default {
  name: 'ProducttypefiletypeShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('producttypefiletype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('producttypefiletype', ['find']),

  },
  methods: {
    ...mapActions('producttypefiletype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
